import PartnerLogo1 from "../../../assets/images/png/partner-logo/enugutech.webp";
import PartnerLogo2 from "../../../assets/images/png/partner-logo/royalbank.webp";
import PartnerLogo3 from "../../../assets/images/png/partner-logo/globalfunds.webp";
import PartnerLogo4 from "../../../assets/images/png/partner-logo/amazon.webp";
import PartnerLogo5 from "../../../assets/images/png/partner-logo/facebook.webp";

const logos = [
  PartnerLogo1,
  PartnerLogo2,
  PartnerLogo3,
  PartnerLogo4,
  PartnerLogo5,
];

const HireLogoStripSection = () => {
  return (
    <section className="bg-white text-center py-9 px-4 border-y border-hire-line">
      <p className="text-gray text-xs font-poppins font-extrabold tracking-widest uppercase">
        Trusted by 150+ high-growth companies
      </p>
      <div className="mt-6 flex flex-wrap justify-center items-center gap-10 md:gap-16">
        {logos.map((logo, index) => (
          <img
            key={index}
            src={logo}
            alt=""
            className="h-8 md:h-10 w-auto max-w-[155px] object-contain opacity-90 hover:opacity-100 transition-all"
          />
        ))}
      </div>
    </section>
  );
};

export default HireLogoStripSection;
